import { render, staticRenderFns } from "./TransformerTab.vue?vue&type=template&id=00bd2f07&scoped=true&"
import script from "./TransformerTab.vue?vue&type=script&lang=js&"
export * from "./TransformerTab.vue?vue&type=script&lang=js&"
import style0 from "./TransformerTab.vue?vue&type=style&index=0&id=00bd2f07&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bd2f07",
  null
  
)

export default component.exports